// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue'

import StarRating from './common/StarRating/StarRating'
import Navbar from './common/Navbar/Navbar'
import Footer from './common/Footer/Footer'
import Providers from './common/Providers/Provider'
import Reviews from './common/Reviews/Reviews'
import Features from './common/Features/Features'
import Offer from './common/Offer/Offer'

import TrackPlan from './directives/track-plan'
import TrackCall from './directives/track-call'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('star-rating', StarRating);
Vue.component('app-navbar', Navbar);
Vue.component('app-footer', Footer);
Vue.component('app-best-providers', Providers);
Vue.component('app-reviews', Reviews);
Vue.component('app-provider-features', Features);
Vue.component('offer-modal', Offer);

Vue.use(BootstrapVue);

window.axios = axios;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js